import { Box, Button, Divider, Typography, useMediaQuery, useTheme } from '@mui/material';
import React, { useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { useAuthContext } from '../../../context';
import { SubNivelAcesso } from '../../../services/api/users/UserServices';

interface IVMInformationProps {
    id: string;
}

export const VMInformation: React.FC<IVMInformationProps> = ({
    id
}) => {
    const theme = useTheme();
    const smDown = useMediaQuery(theme.breakpoints.down('sm'));
    const location = useLocation();
    const navigate = useNavigate();

    const { userData } = useAuthContext();

    const informacoesPermissoes: SubNivelAcesso = useMemo(() => {
        return userData?.nivel_acesso?.informacoes || {};
    }, [userData]);

    const isButtonActive = (path: string) => {
        return location.pathname === path;
    };

    const hasPermission = (permissionValue: string | null | undefined): boolean => {
        return typeof permissionValue === 'string' && permissionValue !== '';
    };

    return (
        <Box
            display={'flex'}
            flexDirection={smDown ? 'column' : 'row'}
            width={'100%'}
            padding={1}
        >
            <Box
                display={'flex'}
                flexDirection={'column'}
                alignItems={smDown ? 'center' : 'start'}
                width={smDown ? '100%' : '50%'}
                padding={0}
            >
                <Typography variant='h6' color={theme.palette.primary.main} marginLeft={1}>Registros Legais</Typography>

                {hasPermission(informacoesPermissoes.central) && (
                    <Button variant={isButtonActive(`/information_dam/${id}/comunication`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/comunication`)}>
                        <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Central de comunicação</Typography>
                    </Button>
                )}

                {hasPermission(informacoesPermissoes.identificacao) && (
                    <Button variant={isButtonActive(`/information_dam/${id}/entrepreneu_id`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/entrepreneu_id`)}>
                        <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Identificação do empreendedor</Typography>
                    </Button>
                )}

                {hasPermission(informacoesPermissoes.caracterizacao) && (
                    <Button variant={isButtonActive(`/information_dam/${id}/features-undertaking`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/features-undertaking`)}>
                        <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Caracterização da barragem</Typography>
                    </Button>
                )}

                {hasPermission(informacoesPermissoes.organograma) && (
                    <Button variant={isButtonActive(`/information_dam/${id}/organization_chart`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/organization_chart`)}>
                        <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Organograma </Typography>
                    </Button>
                )}
            </Box>
            <Divider orientation={smDown ? 'horizontal' : 'vertical'} flexItem variant="fullWidth" />
            {/* <Box
                display={'flex'}
                flexDirection={'column'}
                alignItems={smDown? 'center' : 'start'}
                width={smDown? '100%' : '50%'}
                padding={1}
            >
                <Typography variant='h6' color={theme.palette.primary.main} padding={0} marginLeft={1}>Informações Adicionais</Typography>

                {hasPermission(informacoesPermissoes.arquivosDaBarragem) && ( // Exemplo de um novo item de permissão
                    <Button variant={isButtonActive(`/information_dam/${id}/files`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/files`)}>
                        <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Arquivos da Barragem</Typography>
                    </Button>
                )}
                {hasPermission(informacoesPermissoes.registrosFotograficos) && ( // Exemplo de outro item
                    <Button variant={isButtonActive(`/information_dam/${id}/files`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/files`)}>
                        <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Registros fotográficos</Typography>
                    </Button>
                )}
            </Box> */}
        </Box>
    );
};